import React, { useState, createElement, Component } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Eye, CheckCircle2, AlertTriangle, Upload, Volume2, Image as ImageIcon, Video, Gavel, FileSearch, ExternalLink, Fingerprint } from 'lucide-react';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/Dialog';
import { toast } from 'sonner';
import { Progress } from '../components/Progress';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const items = [{
  id: 'DF-001',
  type: 'audio',
  title: 'Audio "Presiden batalkan bansos"',
  platform: 'TikTok',
  conf: 96,
  status: 'DIKONFIRMASI',
  manip: 'Voice Clone (AI)',
  views: '2.4M'
}, {
  id: 'DF-002',
  type: 'video',
  title: 'Video Presiden di acara fiktif',
  platform: 'X',
  conf: 88,
  status: 'DIKONFIRMASI',
  manip: 'Face Swap + Lip Sync',
  views: '890K'
}, {
  id: 'DF-003',
  type: 'image',
  title: 'Foto rekayasa pertemuan rahasia',
  platform: 'FB',
  conf: 72,
  status: 'INVESTIGASI',
  manip: 'Composite & Retouch',
  views: '124K'
}, {
  id: 'DF-004',
  type: 'audio',
  title: 'Audio Menteri X menerima suap',
  platform: 'TikTok',
  conf: 81,
  status: 'INVESTIGASI',
  manip: 'Voice Synthesis',
  views: '320K'
}, {
  id: 'DF-005',
  type: 'video',
  title: 'Pidato Presiden tone diubah',
  platform: 'YT',
  conf: 65,
  status: 'WASPADA',
  manip: 'Pitch / Tone manipulation',
  views: '45K'
}, {
  id: 'DF-006',
  type: 'image',
  title: 'Meme manipulatif terkait IKN',
  platform: 'IG',
  conf: 55,
  status: 'WASPADA',
  manip: 'Text overlay tendensius',
  views: '78K'
}];
const statusColor: Record<string, string> = {
  DIKONFIRMASI: 'bg-red-500/10 text-red-500',
  INVESTIGASI: 'bg-amber-500/10 text-amber-500',
  WASPADA: 'bg-blue-500/10 text-blue-500'
};
const typeIcon: Record<string, ComponentType<{
  className?: string;
}>> = {
  audio: Volume2,
  video: Video,
  image: ImageIcon
};
export function Deepfake() {
  const [verify, setVerify] = useState<(typeof items)[0] | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const handleUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'video/*,audio/*,image/*';
    input.onchange = () => {
      setIsUploading(true);
      setUploadProgress(0);
      const interval = setInterval(() => {
        setUploadProgress(p => {
          if (p >= 100) {
            clearInterval(interval);
            setIsUploading(false);
            toast.success('File berhasil diunggah dan masuk antrean analisis');
            return 100;
          }
          return p + 10;
        });
      }, 200);
    };
    input.click();
  };
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1681">
      <PageHeader group="Ancaman & Proteksi" title="Deepfake & Synthetic Media Detection" description="Deteksi media sintetis: audio cloning, face swap, video manipulasi, dan komposisi gambar." icon={Eye} extraActions={<Button size="sm" variant="default" onClick={handleUpload} data-id="element-1683">
            <Upload className="size-3.5 mr-1.5" data-id="element-1684" /> Unggah Media
          </Button>} data-id="element-1682" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1685">
        {[{
        l: 'Media Diperiksa 24J',
        v: '47',
        c: 'text-blue-500'
      }, {
        l: 'Dikonfirmasi Sintetis',
        v: '12',
        c: 'text-red-500'
      }, {
        l: 'Avg Confidence',
        v: '78%',
        c: 'text-amber-500'
      }, {
        l: 'Sudah Di-Takedown',
        v: '8',
        c: 'text-emerald-500'
      }].map(k => <Card key={k.l} className="bg-card border-border/50" data-id="element-1686">
            <CardContent className="p-4" data-id="element-1687">
              <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-1688">
                {k.l}
              </p>
              <p className={`font-heading text-2xl font-bold mt-1 ${k.c}`} data-id="element-1689">
                {k.v}
              </p>
            </CardContent>
          </Card>)}
      </div>

      {/* Upload zone */}
      <Card className="bg-card border-border/50 border-dashed" data-id="element-1690">
        <CardContent className="p-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-center sm:text-left" data-id="element-1691">
          {isUploading ? <div className="w-full max-w-md space-y-3" data-id="element-1692">
              <p className="text-sm font-medium" data-id="element-1693">Mengunggah file...</p>
              <Progress value={uploadProgress} className="h-2" data-id="element-1694" />
              <p className="font-mono text-[10px] text-muted-foreground" data-id="element-1695">
                {uploadProgress}%
              </p>
            </div> : <>
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0" data-id="element-1696">
                <Upload className="size-5 text-primary" data-id="element-1697" />
              </div>
              <div className="flex-1" data-id="element-1698">
                <h3 className="font-bold text-sm mb-1" data-id="element-1699">
                  Unggah Media Baru untuk Analisis
                </h3>
                <p className="text-xs text-muted-foreground" data-id="element-1700">
                  Mendukung format Video, Audio, dan Gambar. Maksimal 50MB per
                  file.
                </p>
              </div>
              <Button onClick={handleUpload} data-id="element-1701">Pilih File</Button>
            </>}
        </CardContent>
      </Card>

      {/* Media grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1702">
        {items.map(it => {
        const Icon = typeIcon[it.type];
        return <Card key={it.id} className="bg-card border-border/50 overflow-hidden hover:border-primary/40 hover:shadow-sm transition" data-id="element-1703">
              <div className="h-32 bg-muted/40 border-b border-border/50 flex items-center justify-center relative" data-id="element-1704">
                <Icon className="size-12 text-muted-foreground/40" data-id="element-1705" />
                <div className="absolute top-2 left-2" data-id="element-1706">
                  <Badge variant="outline" className={`font-mono text-[9px] border-none ${statusColor[it.status]}`} data-id="element-1707">
                    {it.status}
                  </Badge>
                </div>
                <div className="absolute top-2 right-2" data-id="element-1708">
                  <span className="font-mono text-[9px] bg-background/80 px-1.5 py-0.5 rounded border border-border/40" data-id="element-1709">
                    {it.platform}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 font-mono text-[9px] text-muted-foreground bg-background/70 px-1.5 py-0.5 rounded" data-id="element-1710">
                  {it.views} views
                </div>
              </div>
              <CardContent className="p-3.5" data-id="element-1711">
                <p className="font-mono text-[10px] text-muted-foreground" data-id="element-1712">
                  {it.id} · {it.type.toUpperCase()}
                </p>
                <h4 className="text-sm font-bold mt-0.5 line-clamp-2" data-id="element-1713">
                  {it.title}
                </h4>
                <p className="text-[11px] text-muted-foreground mt-1.5" data-id="element-1714">
                  Manipulasi:{' '}
                  <span className="font-medium text-foreground/80" data-id="element-1715">
                    {it.manip}
                  </span>
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-border/40" data-id="element-1716">
                  <span className={`font-mono text-[10px] font-bold ${it.conf >= 80 ? 'text-red-600' : it.conf >= 60 ? 'text-amber-600' : 'text-emerald-600'}`} data-id="element-1717">
                    Confidence: {it.conf}%
                  </span>
                  <Button size="sm" variant="outline" className="h-7 text-[10px]" onClick={() => setVerify(it)} data-id="element-1718">
                    <Eye className="size-3 mr-1" data-id="element-1719" /> Verifikasi
                  </Button>
                </div>
              </CardContent>
            </Card>;
      })}
      </div>

      <Dialog open={!!verify} onOpenChange={open => !open && setVerify(null)} data-id="element-1720">
        <DialogContent className="sm:max-w-[500px] border-border/50 bg-background/95 backdrop-blur" data-id="element-1721">
          <DialogHeader data-id="element-1722">
            <DialogTitle className="font-mono text-sm uppercase tracking-wider text-foreground flex items-center gap-2" data-id="element-1723">
              {verify?.type === 'audio' ? <Volume2 className="size-4 text-primary" data-id="element-1724" /> : verify?.type === 'video' ? <Video className="size-4 text-primary" data-id="element-1725" /> : <ImageIcon className="size-4 text-primary" data-id="element-1726" />}
              Hasil Verifikasi Media
            </DialogTitle>
            <DialogDescription className="text-xs" data-id="element-1727">
              Analisis forensik digital untuk mendeteksi manipulasi AI.
            </DialogDescription>
          </DialogHeader>

          {verify && <div className="grid gap-4 py-4" data-id="element-1728">
              <div className="flex items-start justify-between" data-id="element-1729">
                <div data-id="element-1730">
                  <h4 className="font-bold text-sm text-foreground mb-1" data-id="element-1731">
                    {verify.title}
                  </h4>
                  <p className="font-mono text-[10px] text-muted-foreground" data-id="element-1732">
                    ID: {verify.id} • Platform: {verify.platform}
                  </p>
                </div>
                <Badge variant="outline" className={`font-mono text-[9px] ${statusColor[verify.status]}`} data-id="element-1733">
                  {verify.status}
                </Badge>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-1734">
                <div className="p-3 rounded-lg border border-border/50 bg-muted/10" data-id="element-1735">
                  <p className="font-mono text-[9px] uppercase text-muted-foreground mb-1" data-id="element-1736">
                    Confidence Score
                  </p>
                  <p className={`text-2xl font-bold ${verify.conf >= 80 ? 'text-red-500' : verify.conf >= 60 ? 'text-amber-500' : 'text-emerald-500'}`} data-id="element-1737">
                    {verify.conf}%
                  </p>
                </div>
                <div className="p-3 rounded-lg border border-border/50 bg-muted/10" data-id="element-1738">
                  <p className="font-mono text-[9px] uppercase text-muted-foreground mb-1" data-id="element-1739">
                    Tipe Manipulasi
                  </p>
                  <p className="text-sm font-medium text-foreground" data-id="element-1740">
                    {verify.manip}
                  </p>
                </div>
              </div>

              <div className="bg-primary/5 border border-primary/20 rounded-md p-3" data-id="element-1741">
                <h4 className="font-mono text-[10px] font-bold text-primary uppercase tracking-wider mb-2" data-id="element-1742">
                  Detail Forensik
                </h4>
                <ul className="space-y-1.5" data-id="element-1743">
                  <li className="flex items-start gap-2 text-[10px] text-foreground/90" data-id="element-1744">
                    <span className="mt-1 size-1.5 rounded-full bg-primary shrink-0" data-id="element-1745" />
                    Terdeteksi anomali pada frekuensi audio (spektrogram tidak
                    natural).
                  </li>
                  <li className="flex items-start gap-2 text-[10px] text-foreground/90" data-id="element-1746">
                    <span className="mt-1 size-1.5 rounded-full bg-primary shrink-0" data-id="element-1747" />
                    Jejak kompresi algoritma AI generatif ditemukan pada
                    metadata.
                  </li>
                </ul>
              </div>
            </div>}

          <DialogFooter data-id="element-1748">
            <Button variant="outline" onClick={() => setVerify(null)} data-id="element-1749">
              Tutup
            </Button>
            <Button onClick={() => {
            toast.success('Laporan verifikasi dibuat');
            setVerify(null);
          }} data-id="element-1750">
              Buat Laporan
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <RelatedWorkflow currentStep="Verifikasi Deepfake" nextSteps={[{
      to: '/case-management',
      icon: FileSearch,
      label: 'Buat Berkas Kasus',
      desc: 'Pidanakan pembuat & penyebar konten sintetis.'
    }, {
      to: '/legal-evidence',
      icon: Gavel,
      label: 'Paket Bukti Forensik',
      desc: 'Susun chain-of-custody untuk Polri/Kejaksaan.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Takedown request berdasarkan policy violation.',
      badge: 'EKSTERNAL'
    }, {
      to: '/digital-escort',
      icon: Fingerprint,
      label: 'Brief Digital Escort',
      desc: 'Notifikasi tim pelindung VVIP terhadap ancaman.'
    }]} data-id="element-1751" />
    </div>;
}